import React from "react"

function IconStatusOoo({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="status-ooo"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-status-ooo"
      {...props}
    >
      <path
        d="M21.818 12A9.817 9.817 0 0 0 12 2.182 9.816 9.816 0 0 0 2.182 12 9.817 9.817 0 0 0 12 21.818c5.422 0 9.818-4.396 9.818-9.818zm-2.561 0a7.257 7.257 0 1 1-14.514 0 7.257 7.257 0 0 1 14.514 0z"
        fill={color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__secondary"
      />
    </svg>
  )
}

export default IconStatusOoo
